<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center"><span class="smcap">Copyright, 1918, by</span><br/>
D. APPLETON AND COMPANY<br/>
<span class="smcap">Copyright, 1918, by The Frank A. Munsey Company</span><br/>
<br/>
Printed in the United States of America</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3186253215635795556_74210-h-3.htm.vue?4e9b4e6a